import http from "@/utils/http";
let hr = "/hrApi";
// let host = "/oaApi/nvc/public";
// let qrcode = "/qrcodeApi";
// let config = "http://qrcode.nvc-lighting.com.cn";

export default {
  // HR查看是否是HR人员
  selectHrName: (data) => http.post(`${hr}/interview/selectHrName`, data),


  // 岗位管理:未发布/已下架/已发布
  PostManagement: (data) => http.post(`${hr}/HrRecommend/PostManagement`, data),
  // 内推HR端-岗位信息保存
  PostSave: (data) => http.post(`${hr}/HrRecommend/PostSave`, data),
  // 内推HR端-岗位详情
  PostRevise: (data) => http.post(`${hr}/HrRecommend/PostRevise`, data),
  // 内推HR端-人才库
  talentPool: (data) => http.post(`${hr}/HrRecommend/talentPool`, data),
  // 内推HR端-批量修改岗位信息
  PostBatchRevise: (data) => http.post(`${hr}/HrRecommend/PostBatchRevise`, data),
  // 内推HR端-批量下架岗位信息
  PostBatchRevise1: (data) => http.post(`${hr}/HrRecommend/PostBatchRevise1`, data),
  // HR端投递记录（内推）
  selectDeliveryRecordOther: (data) => http.post(`${hr}/interview/selectDeliveryRecordOther`, data),
  // HR端投递记录（自荐）
  selectDeliveryRecordSelf: (data) => http.post(`${hr}/interview/selectDeliveryRecordSelf`, data),
  // HR端投递记录（已处理）
  selectDeliveryHandleRecord: (data) => http.post(`${hr}/interview/selectDeliveryHandleRecord`, data),
  // HR端投递记录详情
  selectDeliveryRecordDetail: (data) => http.post(`${hr}/interview/selectDeliveryRecordDetail`, data),
  // HR查找面试人员
  selectEmployee: (data) => http.post(`${hr}/interview/selectEmployee`, data),
  // HR端面试安排
  interviewPlan: (data) => http.post(`${hr}/interview/interviewPlan`, data),
  // HR端查看当前面试记录
  selectInterviewRecord: (data) => http.post(`${hr}/interview/selectInterviewRecord`, data),
  // HR端查看已面试记录详情
  selectResumeHrDetail: (data) => http.post(`${hr}/interview/selectResumeHrDetail`, data),
  // HR端淘汰面试
  fallInterview: (data) => http.post(`${hr}/interview/fallInterview`, data),
  // HR端通过面试
  passInterview: (data) => http.post(`${hr}/interview/passInterview`, data),
  // HR端安排复试
  secondInterview: (data) => http.post(`${hr}/interview/secondInterview`, data),
  // 查找所有HR
  HrDisplay: (data) => http.post(`${hr}/HrRecommend/HrDisplay`, data),



  // 勋章系统
  // 获取用户信息
  queryByUsername: (data) => http.post(`${hr}/user/queryByUsername`, data),
  // 任务列表
  queryTaskPageList: (data) => http.post(`${hr}/medalTask/queryTaskPageList`, data),
  // 发布/取消任务
  publishCancel: (data) => http.post(`${hr}/medalTask/publishCancel/${data.taskId}/${data.taskStatus}`),
  // publishCancel: (data) => http.post(`${hr}/medalTask/publishCancel`, data),

  // 通过部门名称模糊查询 --- 推送对象
  // findListByName: (data) => http.get(`${hr}/wecomDepartment/findListByName`, { params: data }),
  findListByName: (data) => http.post(`${hr}/wecomDepartment/findListByName`, data),
  // 新增/编辑任务
  addOrUpdateTask: (data) => http.post(`${hr}/medalTask/addOrUpdateTask`, data),
  // 删除
  deleteTask: (data) => http.delete(`${hr}/medalTask/${data}`),

}


